/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unique_Mesh_NamesInputs */



/**
* | output |
* | --- |
* | "Mesh names must be unique" |
*
* @param {Unique_Mesh_NamesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const unique_mesh_names = /** @type {((inputs?: Unique_Mesh_NamesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unique_Mesh_NamesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mesh names must be unique")
	return /** @type {LocalizedString} */ ("Les noms de mesh doivent être uniques")
});